import React from 'react';
import type { FacturesLoadingsType } from '@/types/facture';
import type { ModesReglementsLoadingsType } from '@/types/modeReglement';
import type { PayeurLoadingsType } from '@/types/payeur';
import type { RecusLoadingsType } from '@/types/recu';

type LoadingContextType = {
  facturesLoadings?: FacturesLoadingsType;
  recusLoadings?: RecusLoadingsType;
  modesReglementsLoadings?: ModesReglementsLoadingsType;
  payeurLoadings?: PayeurLoadingsType;
  setFacturesLoadings?: React.Dispatch<React.SetStateAction<FacturesLoadingsType>>;
  setRecusLoadings?: React.Dispatch<React.SetStateAction<RecusLoadingsType>>;
  setModesReglementsLoadings?: React.Dispatch<React.SetStateAction<ModesReglementsLoadingsType>>;
  setPayeurLoadings?: React.Dispatch<React.SetStateAction<PayeurLoadingsType>>;
};

const LoadingContext = React.createContext<LoadingContextType>({
  facturesLoadings: {
    factures: false,
  },
  recusLoadings: {
    recus: false,
  },
  modesReglementsLoadings: {
    modesReglements: false,
    regieModesReglement: false,
  },
  payeurLoadings: {
    factures: false,
  },
  setFacturesLoadings: () => {},
  setRecusLoadings: () => {},
  setModesReglementsLoadings: () => {},
  setPayeurLoadings: () => {},
});

export default LoadingContext;
